<template>

    <el-dialog title="企业认证协议" :visible.sync="dialogVisible.show" width="60%" :close-on-click-modal="false" top="2%" center>


    <div class="protocol-content">
    <!-- 协议标题 -->
    <div style="text-align: center; margin-bottom: 24px;">
      <h2 style="font-size: 22px; font-weight: bold; margin-bottom: 8px;color: #000;">星火链网企业认证协议</h2>

    </div>

    <!-- 鉴于部分 -->
    <div style="margin-bottom: 24px;">
      <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #000;">鉴于：</h3>
      <p style="font-size: 14px; line-height: 1.6; color: #333; text-indent: 2em; margin-bottom: 8px;">
        甲方是"星火·链网（苏州工业园区）骨干节点"的运营单位，拥有提供相关服务的资质与能力；
      </p>
      <p style="font-size: 14px; line-height: 1.6; color: #333; text-indent: 2em; margin-bottom: 8px;">
        乙方是注册并使用甲方运营的"星火·链网（苏州工业园区）骨干节点"服务的企业。
      </p>
      <p style="font-size: 14px; line-height: 1.6; color: #333; text-indent: 2em;">
        各方本着平等互利、诚实信用的原则，达成如下协议：
      </p>
    </div>

    <!-- 第一条 -->
    <div style="margin-bottom: 20px;">
      <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #000;">一、服务内容</h3>
      <div style="background: #fff; border-radius: 4px; padding: 0 16px;">
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>1.1</strong> 甲方同意依据本协议约定的条款，向乙方提供"星火·链网（苏州工业园区）骨干节点"服务（以下简称"本服务"）。
        </div>
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>1.2</strong> 乙方承诺遵守附件《"星火·链网（苏州工业园区）骨干节点"用户使用协议》，并依法使用本服务。
        </div>
        <div style="line-height: 1.6; font-size: 14px; color: #333;">
          <strong>1.3</strong> 乙方如需使用"星火·链网（苏州工业园区）骨干节点"平台付费场景，须与甲方商议并购买相应服务。
        </div>
      </div>
    </div>

    <!-- 第二条 -->
    <div style="margin-bottom: 20px;">
      <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #000;">二、乙方承诺与保证</h3>
      <div style="background: #fff; border-radius: 4px; padding: 0 16px;">
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>2.1</strong> <strong>信息真实性保证：</strong>乙方承诺，在平台注册认证及使用服务过程中所提交的一切资料、信息（包括但不限于企业营业执照、法定代表人身份信息、联系人信息等）均是真实、准确、完整且有效的。乙方理解并同意，甲方有权基于该等信息进行审核，且该等信息将作为乙方身份认证及享受服务的依据。
        </div>
        <div style="line-height: 1.6; font-size: 14px; color: #333;">
          <strong>2.2</strong> 乙方知悉，提供虚假材料将导致注册失败、服务中止或终止，并可能承担相应的法律责任。
        </div>
      </div>
    </div>

    <!-- 第三条 -->
    <div style="margin-bottom: 20px;">
      <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #000;">三、协议有效期</h3>
      <div style="background: #fff; border-radius: 4px; padding: 0 16px;">
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>3.1</strong> 本协议有效期自乙方在线接受或签章之日起，为期<strong style="color: #000;">贰年</strong>。
        </div>
        <div style="line-height: 1.6; font-size: 14px; color: #333;">
          <strong>3.2</strong> 有效期届满前，如乙方希望继续使用本服务，应在协议到期日前的<strong style="color: #000;">三十个工作日</strong>内，主动联系甲方并完成新协议的签署流程。逾期未完成续签的，本协议在到期后自动终止，甲方有权停止向乙方提供服务。
        </div>
      </div>
    </div>

    <!-- 第四条 -->
    <div style="margin-bottom: 20px;">
      <h3 style="font-size: 16px; font-weight: bold; margin-bottom: 12px; color: #000;">四、其他约定</h3>
      <div style="background: #fff; border-radius: 4px; padding: 0 16px;">
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>4.1</strong> 本协议的生效、履行、解释及争议的解决均适用中华人民共和国法律。
        </div>
        <div style="margin-bottom: 12px; line-height: 1.6; font-size: 14px; color: #333;">
          <strong>4.2</strong> 因本协议引起的或与本协议有关的任何争议，双方应友好协商解决；协商不成的，任何一方均有权将争议提交至甲方所在地有管辖权的法院诉讼解决。
        </div>
        <div style="line-height: 1.6; font-size: 14px; color: #333;">
          <strong>4.3</strong> 本协议自乙方完成平台在线勾选同意或双方盖章签署之日起生效。
        </div>
      </div>
    </div>

    <!-- 底部确认提示 -->

    <div class="footer">
      <div class="footer-content">
        <div class="footer-item">认证企业：{{ (infoData.enterprise && infoData.enterprise.fullName) || '--'}}</div>
        <div class="footer-item">认证时间：{{ infoData.createdAt||'--' }}</div>
        <div class="footer-item">企业主体ID：{{ (infoData.enterprise && infoData.enterprise.bid) || '--' }}</div>
        <div class="footer-item">凭证ID：{{ (infoData.enterprise && infoData.enterprise.creBid) || '--' }}</div>
      </div>

    </div>



  </div>


  <!-- 弹窗底部操作 -->




</el-dialog>

</template>

<script>

export default {
  props: {
    dialogVisible: {
      type: Object,
      default: function () {
        return {}
      }
    },
  },
  data() {
    return {
      infoData: {}
    }
  },
  watch: {
    dialogVisible: {
      handler(newVal) {
        this.infoData = newVal.detailData

        console.log(this.infoData)
      }
    },
  },
  methods: {


  }
}
</script>

<style lang="less" scoped>
  .footer{
    display: flex;
    justify-content: flex-end;
    .footer-content{
      font-size: 14px;
      width: 440px;
      color: #333;
      .footer-item{
        margin-bottom: 12px;
      }
    }
  }



</style>
